import React from "react";
import 'chartjs-adapter-moment'
import * as d3module from "d3";
import d3Tip from "d3-tip";
import { getBoundingClientRect } from "../../utils/functions";
import { priceStandardView } from "../../utils/useful";

// d3.tip = d3Tip;
const d3 = {
    ...d3module,
    tip: d3Tip
}



class PackedBubbleChart extends React.Component {

    state = {
        show: true,

    }



    componentDidMount() {

        let datasets = this.props.data?.datasets
        let dataset
        let data
        if (datasets) {
            dataset = datasets[0]
        }

        if (dataset) {
            data = dataset?.data
        }


        // console.log(this.props.data)
        // console.log(dataset)


        if (Array.isArray(data)) {

            data = data.sort(function (a, b) {

                return b.value - a.value

            })

            const values = data?.map(d => d.x);
            this.min = Math.min.apply(null, values);
            this.max = Math.max.apply(null, values);
            this.total = data?.length;
            this.idx = 0;


            // console.log(values)
            // return


            let bound = getBoundingClientRect(this.chartContainer)

            var diameter = bound.width - 20
            // let color = d3.scaleOrdinal(d3.scaleOrdinal);

            var bubble = d3.pack()
                .size([diameter, diameter])
                .padding(0);

            let tip = d3.tip()
                .attr('class', 'd3-tip-outer')
                .offset([-5, 0])
                .html((d, node) => {
                    const item = node.data//this.props.data[0];
                    const color = this.getColor(0, values.length);
                    // console.log(item)
                    // console.log(node)
                    // console.log(d)

                    let html = `<div class="d3-tip br-6" style="background-color: ${"#000000aa"}"><p class="text-bold">${item.label}</p> <p class="mt-1">${item.value.toFixed(2)}</p></div><div class="d3-stem" style="border-color: ${color} transparent transparent transparent"></div>`;
                    // console.log(html)
                    return html
                })

            // console.log(tip)


            var margin = {
                left: 25,
                right: 25,
                top: 0,
                bottom: 25
            }

            var svg = d3.select('#chart').append('svg')
                .attr('viewBox', '0 0 ' + (diameter + margin.right) + ' ' + diameter)
                .attr('width', (diameter + margin.right))
                .attr('height', diameter * 3 / 4)
                .attr('class', 'chart-svg');

            var root = d3.hierarchy({ children: data })
                .sum(function (d) { return d.value; });
            // .sort(function(a, b) { return b.value - a.value; });

            bubble(root);

            var node = svg.selectAll('.node')
                .data(root.children)
                .enter()
                .append('g').attr('class', 'node')
                .attr('transform', function (d) { return 'translate(' + d.x + ' ' + d.y + ')'; })
                .append('g').attr('class', 'graph');

            node.append("circle")
                .attr("r", function (d) { return d.r; })
                .style("fill", this.getItemColor)
                // .style('filter', 'drop-shadow( 0px 0px 10px #00000090)')
                .on('mouseover', tip.show)
                .on('mouseout', (d, i) => tip.hide(d, i));

            node.call(tip);

            node.append("text")
                .attr("dy", "0.2em")
                .style("text-anchor", "middle")
                // .style('font-family', 'Roboto')
                .style('font-size', this.getFontSizeForItem)
                .text(this.getLabel)
                .style("fill", "#000")
                .style('pointer-events', 'none');

            node.append("text")
                .attr("dy", "1.4em")
                .style("text-anchor", "middle")
                // .style('font-family', 'Roboto')
                .style('font-weight', '100')
                .style('font-size', this.getFontSizeForItem)
                .style('font-weight', '600')

                .text(this.getValueText)
                .style("fill", "#000")
                .style('pointer-events', 'none');

        }
    }




    render() {


        return (
            <div className={'h-100 w-100'} ref={el => this.chartContainer = el}>

                <div className="w-100 h-100" ref={el => this.chartContainer = el}>
                    {this.state.show && (
                        <>
                            <div id="chart" class="chart"></div>
                        </>
                    )}

                </div>
            </div>
        )
    }






    getItemColor = (item) => {

        let datasets = this.props.data?.datasets
        let dataset
        let data
        if (datasets) {
            dataset = datasets[0]
        }

        if (dataset) {
            data = dataset?.data
        }

        return this.getColor(this.idx++, data?.length);
    }
    getColor = (idx, total) => {
        // const colorList = ['F05A24', 'EF4E4A', 'EE3F65', 'EC297B', 'E3236C', 'D91C5C', 'BC1E60', '9E1F63', '992271', '952480', '90278E', '7A2A8F', '652D90', '502980', '3B2671', '262261', '27286D', '292D78', '2A3384', '2B388F', '2A4F9F', '2965AF', '277CC0', '2692D0', '25A9E0'];
        // const colorLookup = [
        //     [0, 4, 10, 18, 24],
        //     [0, 3, 6, 9, 11, 13, 15, 18, 20, 24],
        //     [0, 3, 4, 6, 7, 9, 11, 13, 14, 15, 17, 18, 20, 22, 24],
        //     [0, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14, 15, 17, 18, 19, 20, 22, 23, 24],
        //     [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
        // ];
        // for (const idxList of colorLookup) {

        //     if (idxList.length >= total) {
        //         console.log(colorList[idxList[idx]])
        // return '#' + colorList[idxList[idx]];
        //     }
        // }

        return this.getRandomColor()
    }


    getRandomColor(opacity) {


        let colors = ["#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6"]

        let color = colors[Math.floor(Math.random() * colors.length)];

        return color + (opacity ?? 'aa');


    }



    getLabel = (item) => {
        if (item.data.value < this.max / 20) {
            return '';
        }
        return this.truncate(item.data.label);
    }
    getValueText = (item) => {
        if (item.data.value < this.max / 20) {
            return '';
        }
        return item.data.value ? priceStandardView(item.data.value.toFixed(0)) : '';
    }
    truncate = (label) => {
        const max = 14;
        if (label?.length > max) {
            label = label.slice(0, max) + '...';
        }
        return label;
    }
    getFontSizeForItem = (item) => {
        return this.getFontSize(item.data.value, this.min, this.max, this.total);
    }
    getFontSize = (value, min, max, total) => {
        const minPx = 6;
        const maxPx = 34;
        const pxRange = maxPx - minPx;
        const dataRange = max - min;
        const ratio = pxRange / dataRange;
        const size = Math.min(maxPx, Math.round(value * ratio) + minPx);
        return `${size}px`;
    }







}







export default PackedBubbleChart;

